export function invitationExpiryCopy(expiresAt: string | null | undefined): string {
  if (!expiresAt) return "This personal link expires.";
  const date = new Date(expiresAt);
  if (!Number.isFinite(date.getTime())) return "This personal link expires.";
  return `Expires ${date.toLocaleString([], { dateStyle: "medium", timeStyle: "short" })}.`;
}
